import store from '@/ui/store';
import serviceProvider from '@/services/service-provider';
import { firebaseAuth } from '@/plugins/firebase';
import { FirestoreAuthUser } from './services/firestore/firestore.types';

firebaseAuth.onAuthStateChanged(async (auth) => {
  if (auth) {
    let user = null;

    try {
      user = await serviceProvider.auth.onAuthChanged(auth as FirestoreAuthUser);
    } catch (error) {
      console.error(error);
    }

    store.dispatch('user/mountUser', user);
  }
});
